import {
  ExerciseAssetCoachInfoDto,
  ExerciseAssetType,
} from "@growth-machine-llc/stridist-api-client";
import React from "react";
import {
  GenericTemplateTypeBadge,
  privacyTooltip,
} from "../badge/LibraryPrivacyTypeBadge";
import { LibraryPrivacyType } from "../../constants";

interface IExerciseTypeBadgeProps {
  exerciseType: ExerciseAssetType;
  coach?: ExerciseAssetCoachInfoDto;
  showTooltip?: boolean;
  size?: number;
}

const EXERCISE_TO_LIBRARY_PRIVACY_MAP = {
  [ExerciseAssetType.PUBLIC]: LibraryPrivacyType.PUBLIC,
  [ExerciseAssetType.PRIVATE]: LibraryPrivacyType.PRIVATE,
  [ExerciseAssetType.TEAM]: LibraryPrivacyType.TEAM,
};

const ExerciseTypeBadge = ({
  exerciseType,
  coach,
  size = 40,
}: IExerciseTypeBadgeProps) => {
  const privacyType = EXERCISE_TO_LIBRARY_PRIVACY_MAP[exerciseType];

  const tooltip = privacyTooltip(
    "exercise",
    privacyType,
    privacyType === LibraryPrivacyType.TEAM ? coach?.coachName : undefined,
  );

  return (
    <GenericTemplateTypeBadge
      type={privacyType}
      owner={
        coach
          ? {
              photoUrl: coach.coachPhotoUrl,
              displayName: coach.coachName,
            }
          : undefined
      }
      tooltip={tooltip}
      size={size}
      showLabel={false}
    />
  );
};

export default ExerciseTypeBadge;
